import { ButtonProps } from '@/themes/theme'
import styled from 'styled-components'

export const ButtonStyled = styled.button<ButtonProps>`
  font-weight: 400;
  font-family: 'Inter', sans-serif;
  font-size: ${(props) => (props.$fontSize ? props.$fontSize : '14px')};
  line-height: ${(props) => (props.$lineHeight ? props.$lineHeight : '20px')};
  color: ${(props) => (props.$color ? props.$color : 'black')};
  background-color: ${(props) => (props.$bgColor ? props.$bgColor : 'transparent')};
  padding: ${(props) => (props.$padding ? props.$padding : '10px 16px')};
  border: ${(props) => (props.$border ? props.$border : '0px')};
  border-radius: ${(props) => (props.$borderRadius ? props.$borderRadius : '0px')};
  cursor: pointer;
  &:hover {
    color: ${(props) => (props.$hover.$color ? props.$hover.$color : 'black')};
    background-color: ${(props) => (props.$hover.$bgColor ? props.$hover.$bgColor : 'transparent')};
    border: ${(props) => (props.$hover.$border ? props.$hover.$border : '0px')};
  }
  &:disabled {
    color: ${(props) => (props.$disabled.$color ? props.$disabled.$color : 'black')};
    background-color: ${(props) => (props.$disabled.$bgColor ? props.$disabled.$bgColor : 'transparent')};
    border: ${(props) => (props.$disabled.$border ? props.$disabled.$border : '0px')};
  }
`
